import { css } from '@emotion/react';

const dropDownStyles = css`
    .drop-down-button {
        display: block;
        padding: 0.5em;
    }

    .selection {
        width: 100%;
    }

    .select-option {
        font-size: 1em;
    }
`;

export const themeDropDownStyles = css`
    font-family: var(--body-fontFamily);
    font-size: var(--body-fontSize);
    font-weight:  var(--body-fontWeight);

    h5 {
        font-family: var(--heading-level-five-fontFamily);
        font-size: var(--heading-level-five-fontSize);
        font-weight:  var(--heading-level-five-fontWeight);
    }

    .drop-down-button {
        display: block;
        padding: 0.5em;
    }

    .selection {
        width: 100%;
    }

    .select-option {
        font-size: var(--body-fontSize);
        font-weight:  var(--body-fontWeight);
    }

    .ant-select,
    .selection {
        width: 120px;
    }

    .ant-select-dropdown {
        min-width: 120px;
        width: auto;
    }

    .ant-select {
        min-width: 120px;
    }

    .ant-select-selector {
        height: 45px !important;
        align-items: center;
        font-size: var(--body-fontSize);
        font-weight:  var(--body-fontWeight);
        cursor: pointer;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.5);
    }

    .ant-select-arrow {
        font-size: var(--body-fontSize); !important;
        font-weight:  var(--body-fontWeight);
        font-weight: bolder;

        svg > path {
            stroke: black;
            stroke-width: 5rem;
        }
    }
`;

export default dropDownStyles;
